import React from 'react';
import Jumbotron from '../component/Jumbotron';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import Shop from './Shop';

export default function FinalShop() {
  return (
    <>
      <div>
        <Container>
          <Jumbotron />
        </Container>
      </div>
      <div clasName='container-finalshop'>
        <Container>
          <Shop />
        </Container>
      </div>
    </>
  );
}
